export { Buffer } from 'buffer';
export const process = { cwd: () => '/', platform: 'browser', env: {} };
